import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Check, ArrowLeft } from 'lucide-react';
import Navbar from '../components/landing/Navbar';
import Footer from '../components/landing/Footer';
import { useAuth } from '../contexts/AuthContext';

const ComoFunciona = () => {
  const { user } = useAuth();
  const steps = [
    { number: '01', title: 'Faça seu cadastro', description: 'Crie sua conta gratuitamente em minutos. Suporte para médicos e veterinários.', details: ['Cadastro simples e rápido', 'Sem necessidade de cartão de crédito', 'Acesso imediato à plataforma', 'Suporte para profissionais de saúde'] },
    { number: '02', title: 'Configure seu perfil', description: 'Adicione suas assinaturas, locais de atendimento e templates de laudo.', details: ['Configure suas assinaturas visuais', 'Adicione seus locais de atendimento', 'Crie templates personalizados', 'Importe seus dados facilmente'] },
    { number: '03', title: 'Comece a emitir', description: 'Crie laudos profissionais, adicione imagens e registre com hash de integridade.', details: ['Emita laudos em minutos', 'Adicione imagens e anexos', 'Registre com hash de integridade', 'Compartilhe com pacientes'] }
  ];

  const benefits = [
    { title: 'Economize tempo', description: 'Menos digitação por laudo com templates e automação.' },
    { title: 'Integridade registrada', description: 'Seus laudos são armazenados com segurança e registrados com hash de integridade.' },
    { title: 'Validação online', description: 'Cada laudo ganha QR Code e página pública de validação para o paciente conferir.' },
    { title: 'Suporte em português', description: 'Atendimento pelo WhatsApp.' }
  ];

  return (
    <div className="min-h-screen bg-paper-alt">
      <Navbar />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <Link to="/" className="inline-flex items-center min-h-[44px] text-muted hover:text-ink mb-8 transition-colors">
          <ArrowLeft className="w-4 h-4 mr-2" aria-hidden="true" /> Voltar para a página inicial
        </Link>

        <div className="text-center mb-16">
          <h1 className="font-display text-4xl font-bold text-navy">Como funciona</h1>
        </div>

        {/* Passos: mesma numeração 01/02/03 da landing */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {steps.map((step) => {
            return (
              <motion.div
                key={step.number}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                className="bg-paper rounded-card shadow-card border border-line p-8 text-center"
              >
                <div className="font-display text-4xl font-bold text-navy mb-4">{step.number}</div>
                <h3 className="font-display text-xl font-bold text-ink mb-4">{step.title}</h3>
                <p className="text-muted mb-6 text-sm leading-relaxed">{step.description}</p>
                <ul className="space-y-2 text-left">
                  {step.details.map((detail, detailIndex) => (
                    <li key={detailIndex} className="flex items-start text-sm text-muted">
                      <Check className="w-4 h-4 text-selo mr-2 flex-shrink-0 mt-0.5" aria-hidden="true" />
                      {detail}
                    </li>
                  ))}
                </ul>
              </motion.div>
            );
          })}
        </div>

        {/* Benefícios */}
        <div className="mb-16">
          <h2 className="font-display text-2xl font-bold text-navy mb-8 text-center">
            Por que usar o Laudando
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {benefits.map((benefit) => {
              return (
                <motion.div
                  key={benefit.title}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  className="bg-paper rounded-card shadow-card border border-line p-6"
                >
                  <h3 className="font-display text-lg font-bold text-ink mb-2">{benefit.title}</h3>
                  <p className="text-muted text-sm leading-relaxed">{benefit.description}</p>
                </motion.div>
              );
            })}
          </div>
        </div>

        {/* CTA */}
        <div className="bg-navy-2 rounded-card p-8 text-center">
          <h2 className="font-display text-3xl font-bold text-white mb-6">
            Comece agora
          </h2>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            {user ? (
              <Link to="/app/painel" className="btn-primary bg-white !text-navy hover:bg-paper-alt text-base px-8">
                Ir para o Dashboard
              </Link>
            ) : (
              <Link to="/login" className="btn-convert text-base px-8">
                Criar conta grátis
              </Link>
            )}
            <Link to="/recursos" className="btn-secondary !text-white bg-white/10 border-white/20 hover:bg-white/20 text-base px-8">
              Ver recursos
            </Link>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ComoFunciona;
